document.addEventListener("DOMContentLoaded", function () {

const sections = document.querySelectorAll('.shopify-section:not(.no-section-animation)');

const sectionObserver = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('visible');
      observer.unobserve(entry.target);
    }
  });
}, { threshold: 0.05 });

sections.forEach(section => {

  if (section.querySelector('#floatingTrendingProduct')) return true;
  if (section.id.includes('__product-grid')) return true;
  if (section.id.includes('__whatsapp_floating_icon_BcxLeL')) return true;

  section.classList.add('animate-section');
  sectionObserver.observe(section);

  const rect = section.getBoundingClientRect();
  if (rect.top < window.innerHeight * 0.9) {
    section.classList.add('visible');
  }
});

const revealElements = document.querySelectorAll('.shopify-section h2');

revealElements.forEach(el => {
  el.classList.add('reveal-text');
});

const revealOnScroll = () => {
  revealElements.forEach(el => {
    if (!el.classList.contains('animate')) {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.85) {
        el.classList.add('animate');
      }
    }
  });
};

revealOnScroll();

let ticking = false;

window.addEventListener("scroll", function () {
  if (!ticking) {
    window.requestAnimationFrame(function () {
      revealOnScroll();
      ticking = false;
    });
    ticking = true;
  }
});

});